import React from "react";

import "./Styles/globalStyle.css";

import Routes from "./routes";

function App() {
  return (
    <>
      <Routes />
    </>
  );
}

export default App;
